/****　まい泉カスタマイズJS　****/

/* トップ　重要なお知らせ　開閉　*/	
  var button = document.getElementsByClassName('important-notice_article_button');
 
  for (i = 0; i < button.length; i++) {
    button[i].addEventListener("click", function() {	  
      if(this.getAttribute('aria-expanded') === 'false') {
	    this.setAttribute('aria-expanded', 'true');
	  } else if(this.getAttribute('aria-expanded') === 'true') {
	    this.setAttribute('aria-expanded', 'false');
	  }				
    });
  }

//配送日選択のplaceholder追加
// let elem = document.getElementById("delivery-date-pro");
// if (elem) {
//     elem.placeholder = "選択してください";
// }
